<template>
  <div class="content">
    <el-table :data="tabeData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="startTime" label="发送时间" align="center"></el-table-column>
      <el-table-column prop="vol" label="用量" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="callType" label="MO/MT" width="120" align="center"></el-table-column>
      <el-table-column prop="country" label="国家" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="channel" label="渠道" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="billMonth" label="账单日期" align="center" width="160"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
      />
  </div>
</template>
<script>
import { internationalSmsRecords } from "@/api/international.js"; //订单列表
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  data() {
    return{
      total:0,
      page:1,
      pageSize:20,
      tabeData:[],
    }
  },
  methods: {
    // 获取话单数据
    initData(){
      let params = {
        model:{
					iccid:this.iccid,
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalSmsRecords(params).then(res =>{
        this.total = res.data.data.total;
        this.tabeData = res.data.data.records;
      })
    },
  },
  created() {
    this.initData()
  }
};
</script>



